import styled from "styled-components";

const Body = styled.p`
  font-family: ${({ theme }) => theme.fonts.body.family};
  font-size: ${({ theme }) => theme.fonts.body.fontSize};
  line-height: ${({ theme }) => theme.fonts.body.lineHeight};
  font-weight: ${({ theme }) => theme.fonts.body.fontWeight};
  letter-spacing: ${({ theme }) => theme.fonts.body.letterSpacing};
  max-width: ${({ theme }) => theme.copyMaxWidth};
  white-space: pre-wrap;
  color: ${({ theme }) => theme.colors.typographyDefault};

  a {
    font-family: ${({ theme }) => theme.fonts.link.family};
    font-size: ${({ theme }) => theme.fonts.link.fontSize};
    line-height: ${({ theme }) => theme.fonts.link.lineHeight};
    font-weight: ${({ theme }) => theme.fonts.link.fontWeight};
    letter-spacing: ${({ theme }) => theme.fonts.link.letterSpacing};
  }
`;

export default Body;
